export const DELIVERY_PLAN_DESCRIPTIONS: Record<string, string> = {
  EA: 'Entrega programada desde la tienda de facturación según fecha y dirección pactadas.',
  PCE: 'Pago y entrega en un punto de recepción distinto a la tienda donde se facturó.',
  EB: 'Retiro de la mercancía en la bodega de la misma tienda donde se realizó la facturación.',
  PE: 'Pago en tienda con recogida diferida en fecha acordada, cuando la mercancía esté disponible.',
  ED: 'Facturación en tienda origen y retiro en tienda destino diferente.',
  DI: 'Facturación y recogida instantánea en el punto de venta (sin envío).',
  EDP: 'Facturación en tienda con entrega gestionada por proveedor, sin afectar el stock de la tienda.',
  IP: 'Facturación vía marketplace sobre inventario centralizado, con entrega directa del proveedor o desde tienda.'
};
